export class DimensionOptionSelectorResultDto {
    code: string;
    text: string;
}
